import { render, staticRenderFns } from "./BehaviorGoalProgress.vue?vue&type=template&id=4ac5373c&scoped=true"
import script from "./BehaviorGoalProgress.vue?vue&type=script&lang=js"
export * from "./BehaviorGoalProgress.vue?vue&type=script&lang=js"
import style0 from "./BehaviorGoalProgress.vue?vue&type=style&index=0&id=4ac5373c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5373c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
